import { render, staticRenderFns } from "./HelloWorld2.vue?vue&type=template&id=e9e2b31c&scoped=true&"
import script from "./HelloWorld2.vue?vue&type=script&lang=js&"
export * from "./HelloWorld2.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld2.vue?vue&type=style&index=0&id=e9e2b31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e2b31c",
  null
  
)

export default component.exports